(function () {
    'use strict';
    var m = angular.module('common');
    m.factory('reportAsMisClassificationParams', ["modals", "path", function (modals, path) {
        return {
            show: function (title, type) {
                var params = [];
                var modalArgs;
                if (type) {
                    params = [
                        {
                            id: 'static',
                            type: 'message',
                            paramStyle: { 'width': '100%' },
                            message: 'Reporting mis-classification improves the accuracy of the Anti-Phishing service. The machine-learning algorithms will process this feedback and automatically make adjustments accordingly.'
                        },
                        {
                            id: 'status',
                            type: 'selector',
                            label: 'Report this email as',
                            variants: [
                                {
                                    id: 'marketing_email',
                                    label: 'Legit Marketing Email'
                                },
                                {
                                    id: 'clean',
                                    label: 'Clean Email'
                                },
                                {
                                    id: 'spam',
                                    label: 'Spam'
                                },
                                {
                                    id: 'phishing',
                                    label: 'Phishing'
                                }
                            ],
                            validation: { required: true }
                        },
                        {
                            id: 'confident',
                            type: 'selector',
                            label: 'How confident are you?',
                            variants: [
                                {
                                    id: 'not_so_sure',
                                    label: 'Not so sure'
                                },
                                {
                                    id: 'medium',
                                    label: 'Medium Confidence'
                                },
                                {
                                    id: 'very',
                                    label: 'High Confidence'
                                }
                            ],
                            data: 'not_so_sure'
                        }
                    ];
                } else {
                    params = [{
                            id: 'static',
                            type: 'message',
                            paramStyle: { 'width': '100%' },
                            message: 'This report will be processed automatically by our Anti-Phishing service and will be used to improve the accuracy of your phishing detection.'
                        }];
                    modalArgs = {
                        leftText: '#' + JSON.stringify({
                            display: 'linked-text',
                            'class': 'app-logo-container',
                            text: '#' + JSON.stringify({
                                display: 'img',
                                'class': 'app-logo',
                                path: path('common').img('machine-learning.png')
                            })
                        }),
                        bodyClass: 'license-modal-body'
                    };
                }
                if (type) {
                    return modals.params([{
                            lastPage: true,
                            params: params
                        }], title);
                }
                return modals.params([{
                        lastPage: true,
                        okButton: 'Close',
                        hideDefaultButton: true,
                        params: params
                    }], title, 'md', modalArgs);
            }
        };
    }]);
}());